import React from 'react'
import { Link } from 'gatsby'
import { Flex, Button, Heading } from 'theme-ui'
// import { FaBookReader as Book } from 'react-icons/fa'
import { SiCoffeescript as Coffee } from 'react-icons/si'
// import BookImg from '../../../components/book'

// update the to url below when changing the book I'm currently reading.
// Copy the code from Amazon Affiliate image-> Medium.
// href comes from the first a tag.

const styles = {
  wrapper: {
    alignItems: `center`,
    flexDirection: `column`,
    bg: `omegaLighter`,
    borderRadius: `lg`,
    size: `full`,
    p: 4,
    opactity: 1,
    overflow: `visible`,
    width: `100%`
  },
  gatsbyImageWrap: {
    width: `100%`
  },
  img: {
    opactity: 1,
    width: `100%`
  },
  heading: {
    color: `omegaDark`,
    wordSpacing: 500, //force line breaks
    svg: {
      color: `alpha`,
      size: `icon.lg`,
      display: `block`,
      mb: 3
    }
  },
  subheading: {
    color: `omegaDark`,
    fontWeight: `normal`
  },
  list: {
    color: `omegaDark`,
    listStyle: `none`,
    m: 0,
    p: 0,
    li: {
      p: 0,
      my: 2
    },
    'li:before': {
      content: `""`,
      display: `inline-block`,
      width: `icon.xs`,
      bg: `success`,
      borderRadius: `full`,
      size: `7px`,
      mr: `7px`
    }
  },
  button: {
    display: `block`,
    mt: `auto`
  }
}

const BannerVertical = () => {
  return (
    <Flex sx={styles.wrapper}>
      <Heading variant='h2' sx={styles.heading}>
        <Coffee />
        Fuel an Idea
      </Heading>
      <Heading variant='h4' sx={styles.subheading}>
        Every week, I break down complex ideas, strip away the fluff, and give
        you experiments to turn knowledge into skills.
        <br />
        <br />
        If that’s worth a coffee, consider fueling the next big insight.
        <br />
        <br />
        No pressure. No guilt trips. Just impact.
      </Heading>
      <Button
        variant='primary'
        as={Link}
        to='https://agileambition.kit.com/products/donate?utm_source=website&utm_medium=vertical-banner&utm_campaign=donate&utm_content=buy-me-a-coffee'
        sx={styles.button}
        aria-label='Snag a Copy'
      >
        Buy Me a Coffee
      </Button>
    </Flex>
  )
}

export default BannerVertical
